/**
 * Trạng thái đơn vị
 */
 export default {
    Default: 1,
    Delete: 2
};
  